import "regenerator-runtime/runtime"
import "core-js/stable"
import Q from 'q'
import {ioc} from 'internal-ioc'
import _ from 'lodash'
import modDeviceApi from 'device-api/device'
import modDeviceGetApiAddress from 'device-api/get-api-address'
import modDeviceHelpers from 'device-api/helpers'
import getSchemeSettingsHelper from './getSchemeSettings'
import chiHelpers from 'content-hosting-interface-helpers/helpers'
import gameDevice from 'content-hosting-interface-helpers/game-device'
import gameRandom from 'content-hosting-interface-helpers/game-random'
import gameThrows from 'content-hosting-interface-helpers/game-throws'
import modLogin from 'login-api/login'
import modLoginLookup from 'login-api/lookup'
import modLoginHelpers from 'login-api/helpers'
import modLoginRegistrationChecks from 'login-api/registration-checks'
import modMessageHelpers from 'message-api/helpers'
import modMessageContent from 'message-api/content'

const getNewInjectionInstance = async (schemeId, serverUrl) => {
    window.apiAddress = serverUrl || window.apiAddress || window.location.origin
    ioc.define("Promise", Promise)
    ioc.define("window", window)
    ioc.define("Q", Q)
    ioc.define("_", _)
    ioc.injectAll(modDeviceHelpers)
    ioc.injectAll(modDeviceGetApiAddress)
    ioc.injectAll(modDeviceApi)
    ioc.injectAll(getSchemeSettingsHelper)
    const schemeSettings = await ioc.run(getSchemeSettingsHelper.getSchemeSettingsSymbol, schemeId)
    ioc.define("3r/schemeSettings/webapp", schemeSettings)
    ioc.define("3r/storage",{
        setItem : function (name, value) {
            if (!name) {
                return
            }
            
            if (name.endsWith("_thrid") || name == "device-id") {
                localStorage.setItem(name, value)
            }
        },
        getItem : function (name) {
            if (name.endsWith("_thrid") || name == "device-id") {
                return localStorage.getItem(name)
            }
        },
        removeItem : function (name) {
            if (name.endsWith("_thrid") || name == "device-id") {
                return localStorage.removeItem(name)
            }
        },
        clear : function () {
            return localStorage.clear()
        }
    })

    
    

    var Device = window.Device = ioc.run(
        "3r/device-api/device/deviceFactory",
        { schemeId : schemeSettings.globals.schemeId, paused : !schemeSettings.globals.unpauseDevice }
    )

    ioc.define("3r/Device", window.Device)



    ioc.define("3r/chi/helpers", chiHelpers)
    ioc.define("3r/chi/systemMessage", function (messageObj) {
        alert(messageObj.message) 
    })

    console.log(gameDevice)

    ioc.inject(gameDevice.factory)
    ioc.inject(gameRandom.factory)
    ioc.inject(gameThrows.factory)

    function modulesFactory(ioc, Device, factories, navigation, showMessageToUserFn, vocoMessage) {
        var factoryModules = {}
        
        for (var name in factories) {
            if (factories.hasOwnProperty(name)) {
                factoryModules[name] = factories[name](vocoMessage)
            }
        }
        
        factoryModules.device.gameNavigation = navigation
        
        return Object.assign(
            factoryModules,
            {
                realDevice : Device,
                ioc : ioc,
                navigation : navigation,
                message : showMessageToUserFn
            }
        )
    }

    modulesFactory._depends = {
        symbol : "3r/chi/moduleFactory",
        modules : [
            "3r/ioc",
            "3r/Device",
            /3r\/chi\/factories\//
        ]
    }

    ioc.inject(modulesFactory)



    ioc.injectAll(modLogin)
    ioc.injectAll(modLoginLookup)
    ioc.injectAll(modLoginHelpers)
    ioc.injectAll(modLoginRegistrationChecks)




    ioc.injectAll(modMessageHelpers)
    ioc.injectAll(modMessageContent)

    var registrationChecks = []
    ioc.define("3r/registrationChecks", registrationChecks)
    ioc.call([/3r\/login-api\/registration-checks\//], function (regCheckMods) {
        for (var modName in regCheckMods) {
            registrationChecks.push(regCheckMods[modName].bind(null))
        }
    })
    function passRegistration(_, Q, registrationChecks) {
        return Q.all(registrationChecks.map(c => c()))
            .then(function (results) {
                return _.every(results, Boolean)
            })
    }
    passRegistration._depends = {
        symbol : "3r/passRegistration",
        modules : ["_", "Q", "3r/registrationChecks"]
    }
    ioc.inject(passRegistration)

    return ioc
}


const ModuleInjections = {
    getNewInjectionInstance: getNewInjectionInstance
}


export default ModuleInjections;